import { exportToExcel } from "./exportUtils";

export const exportInitialQuotationData = (quotations) => {
  if (!quotations || quotations.length === 0) {
    throw new Error("No initial quotation records available to export.");
  }

  const exportData = quotations.map((q) => {
    const fullName = q.customerName || `${q.firstName || ""} ${q.lastName || ""}`.trim() || "No Name";
    const phone = q.phoneNumber || q.phone || "No Phone";
    const email = q.email || "No Email";
    
    // Formatting Last Note
    let displayNote = q.stageNotes?.initial_quotation || q.quotationNote || "";
    if (displayNote && typeof displayNote === 'string') {
      if (displayNote.includes(' | Note: ')) {
        displayNote = displayNote.split(' | Note: ')[1].trim();
      } else if (
        displayNote.startsWith('Lead Status changed') ||
        displayNote.startsWith('Design Status changed') ||
        displayNote.startsWith('Appointment scheduled') ||
        displayNote.startsWith('Lead assigned') ||
        displayNote.startsWith('Lead reassigned')
      ) {
        displayNote = "";
      }
    }

    return {
      "Verve ID": (q.customId || "—").toUpperCase(),
      "Customer Name": fullName,
      "Phone": phone,
      "Email": email,
      "Last Note": displayNote || "—",
      "Quotation Amount": q.quotationAmount ? `₹${q.quotationAmount.toLocaleString('en-IN')}` : "—",
      "Status": q.leadStatus?.replace('_', ' ') || "—"
    };
  });

  exportToExcel(exportData, "Initial_Quotations_Export");
};
